import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Optional, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './error-adding-participant.dialog.html',
    styleUrls: ['./error-adding-participant.dialog.scss'],
})
export class ErrorAddingParticipantDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    public errorMsg: string;

    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ErrorAddingParticipantDialog>,
        @Optional() @Inject(MAT_DIALOG_DATA) data: string
    ) {
        super(parentEvents, el, renderer);
        this.errorMsg = data || 'error.general';
    }

    onClose() {
        this.dialogRef.close();
    }
}
